import CheckBox from 'devextreme-react/check-box';
import DataGrid, {
	Column,
	FilterPanel,
	FilterRow,
	HeaderFilter,
	Pager,
	Paging,
	Sorting,
} from 'devextreme-react/data-grid';
import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Confirm } from 'semantic-ui-react';
import { giayToNopApi } from '../../../api/giayToNopApi';
import { loaiGiayToApi } from '../../../api/loai_giay_to';
import { DangerButton, DefaultButton, PrimaryButton } from '../../../components/editor/button';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import styles from '../../hoc-sinh-profile/dich-vu/detail-modal/DangKyDichVuDetailMoal.module.css';

const GiayToNopForm = ({ hocSinh, onUploadedAvatar }) => {
	const iniState = {
		giaytonop_inserts: [],
	};
	const actionTypes = {
		SET_GIAYTONOP_INSERT: 'SET_GIAYTONOP_INSERT',
	};
	const reducer = (state, action) => {
		switch (action.type) {
			case actionTypes.SET_GIAYTONOP_INSERT:
				return {
					...state,
					giaytonop_inserts: action.payload,
				};
			default:
				return state;
		}
	};

	const [isLoading, setIsLoading] = useState(false);
	const [loaiGiayTos, setLoaiGiayTos] = useState([]);
	const [giayToNops, setGiayToNops] = useState([]);
	const [giayToNopChiTietDeltedId, setGiayTopNopChiTietDeletedId] = useState(0);
	const componentDidMount = useRef(false);
	const { translate } = useCommonContext();
	const uploadFileBtns = useRef([]);
	const [isShowInsertConfirm, setIsShowInsertConfirm] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [state, dispatch] = useReducer(reducer, iniState);
	const { trigger } = useForm();

	useEffect(() => {
		componentDidMount.current = true;
		handleGetLoaiGiayTos();
		handleGetGiayToNops();
		return () => {
			componentDidMount.current = false;
		};
	}, [hocSinh]);
	const handleGetLoaiGiayTos = async () => {
		setIsLoading(true);
		const res = await loaiGiayToApi.Select({
			nam_hoc: hocSinh.nam_hoc,
			dm_truong_id: hocSinh.dm_truong_id,
			dm_khoi_id: hocSinh.dm_khoi_id,
			dm_he_id: hocSinh.dm_he_id,
		});
		if (!componentDidMount.current) return;
		if (res.is_success) {
			setLoaiGiayTos(res.data);
		}
	};
	const handleGetGiayToNops = async () => {
		setIsLoading(true);
		const res = await giayToNopApi.SelectByHocSinh(hocSinh.id);
		if (!componentDidMount.current) return;
		if (res.is_success) {
			setGiayToNops(res.data);
		}
	};
	const dataSource = useMemo(() => {
		return loaiGiayTos.map((x) => {
			const giayToNop = giayToNops.find((y) => y.dm_loaigiayto_id == x.id);
			return {
				...x,
				giay_to_nop: giayToNop,
				is_danop: giayToNop == null ? false : giayToNop.is_danop,
			};
		});
	}, [loaiGiayTos, giayToNops]);
	const handleUploadFiles = (data) => async (e) => {
		const formData = new FormData();
		Array.from(e.target.files).forEach((file) => {
			formData.append('formFiles', file);
		});
		const dm_loaigiayto_id = data.id;
		const ts_hocsinh_id = hocSinh.id;
		const res = await giayToNopApi.Upload({
			dm_loaigiayto_id,
			ts_hocsinh_id,
			formFiles: formData,
		});
		if (!componentDidMount.current) return;
		if (res.is_success) {
			handleGetGiayToNops();
			const loaiGiayTo = loaiGiayTos.find((x) => x.id == dm_loaigiayto_id);
			if (loaiGiayTo && loaiGiayTo.is_avatar) {
				onUploadedAvatar();
			}
		}
	};
	const handleDeleteGiayToChiTiet = async () => {
		const res = await giayToNopApi.DeleteChiTiet(giayToNopChiTietDeltedId);
		if (!componentDidMount.current) return;
		if (res.is_success) {
			handleGetGiayToNops();
			setGiayTopNopChiTietDeletedId(0);
		}
	};
	const onInsertClick = () => {
		setIsShowInsertConfirm(true);
	};
	const handleSaveChanges = async (datas) => {
		trigger().then(async (isValid) => {
			if (isValid) {
				setIsSaving(true);
				const dataIntert = { ts_giaytonops: state.giaytonop_inserts, ts_hocsinh_id: hocSinh.id };
				const res = await giayToNopApi.Inserts(dataIntert);
				setIsSaving(false);
				if (res.is_success) {
					showNotify({ text: translate('Cập nhật thành công '), type: 'success' });
					handleGetGiayToNops();
					setIsShowInsertConfirm(false);
				} else {
					showNotify({ text: res.message, type: 'error' });
				}
			}
		});
	};
	const uploadCellRender = (cell) => {
		return (
			<div style={{ textAlign: 'center' }}>
				<input
					type='file'
					multiple
					accept='image/*,application/pdf'
					style={{ display: 'none' }}
					ref={(el) => (uploadFileBtns.current[cell.data.id] = el)}
					onChange={handleUploadFiles(cell.data)}
				></input>
				<span
					style={{ cursor: 'pointer' }}
					onClick={() => {
						uploadFileBtns.current[cell.data.id].click();
					}}
				>
					<i className='fas fa-upload'></i>
				</span>
			</div>
		);
	};
	const FilePreView = ({ file }) => {
		const imgExtensions = ['jpg', 'png', 'jpeg'];
		const fileExtension = file.ten_file.split('.')[file.ten_file.split('.').length - 1];
		return (
			<div
				style={{
					display: 'flex',
					width: 50,
					justifyContent: 'center',
				}}
			>
				{imgExtensions.includes(fileExtension) && (
					<img
						src={file.duong_dan}
						style={{
							width: 20,
							borderRadius: '2px',
						}}
					/>
				)}
				{fileExtension == 'pdf' && (
					<img
						src='../../images/pdf.png'
						style={{
							width: 20,
						}}
					/>
				)}
				{!imgExtensions.includes(fileExtension) && fileExtension != 'pdf' && (
					<img
						src='../../images/document.png'
						style={{
							width: 20,
						}}
					/>
				)}
			</div>
		);
	};
	const fileCellRender = (cell) => {
		const ts_giaytonop_chitiets = cell.data.giay_to_nop?.ts_giaytonop_chitiets;
		// console.log({ xxx: cell.data });
		return (
			<div>
				{ts_giaytonop_chitiets &&
					ts_giaytonop_chitiets.map((x, idx) => {
						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									marginBottom: '5px',
									paddingBottom: '5px',
									// borderBottom: "1px solid #ececec"
								}}
							>
								<FilePreView file={x} />
								<a target={'_blank'} href={x.duong_dan} style={{ width: '200px', overflow: 'hidden' }}>
									{x.ten_file}
								</a>
								<a
									style={{ cursor: 'pointer' }}
									onClick={() => {
										setGiayTopNopChiTietDeletedId(x.id);
									}}
								>
									<i className='fas fa-trash icon trash'></i>
								</a>
							</div>
						);
					})}
			</div>
		);
	};
	const checkboxCellRender = (cell) => {
		return (
			<div>
				<span style={{ cursor: 'pointer' }} onClick={() => {}}>
					<CheckBox
						defaultValue={cell.data.is_danop}
						onValueChanged={(e) => {
							let _inserts = state.giaytonop_inserts;
							const dataIndex = _inserts.findIndex((item) => item.dm_loaigiayto_id === cell.data.id);
							if (dataIndex != -1) {
								_inserts.splice(dataIndex, 1);
							}
							_inserts.push({
								ts_hocsinh_id: hocSinh.id,
								dm_loaigiayto_id: cell.data.id,
								is_danop: e.value,
							});

							dispatch({ type: actionTypes.SET_GIAYTONOP_INSERT, payload: _inserts });
						}}
					></CheckBox>
				</span>
			</div>
		);
	};
	return (
		<div>
			<DataGrid
				keyExpr='id'
				dataSource={dataSource}
				columnHidingEnabled={true}
				columnAutoWidth={true}
				showBorders={true}
				showColumnLines={true}
				showRowLines={true}
				rowAlternationEnabled={true}
				allowColumnResizing={true}
				columnResizingMode={'nextColumn'}
				hoverStateEnabled={true}
				focusedRowEnabled={false}
				// height={window.innerHeight - 150}
			>
				<Column
					visibleIndex={0}
					caption={'#'}
					cellRender={(cell) => <span>{cell.rowIndex + 1}</span>}
					width={40}
					alignment='center'
				/>
				<Column caption={translate('Tên giấy tờ')} dataField='loai_giay_to' />
				<Column width='250' caption={translate('Files')} cellRender={fileCellRender} />
				<Column width='80' alignment='center' caption={translate('Đã nộp')} cellRender={checkboxCellRender} />

				<Column caption={'Upload'} cellRender={uploadCellRender} alignment='center' width={100} />
				<Sorting mode='multiple' />
				<Paging defaultPageSize={50} />
				<FilterRow visible={true} />
				<FilterPanel visible={false} />
				<HeaderFilter visible={true} />
				<Pager
					showPageSizeSelector={true}
					allowedPageSizes={[10, 20, 50, 200, 500]}
					infoText={`${translate('Trang')} {0} /{1} ({2} ${translate('dòng')})`}
					showInfo={true}
				/>
			</DataGrid>
			{dataSource.length > 0 && (
				<div className={styles.tool_bar}>
					<div
						style={{
							display: 'flex',
							justifyContent: 'flex-end',
							marginRight: 20,
							marginTop: 10,
						}}
					>
						<PrimaryButton text={'Cập nhật'} onClick={onInsertClick} isLoading={isSaving} />
					</div>
				</div>
			)}

			{giayToNopChiTietDeltedId > 0 && (
				<Confirm
					className={styles.modal_center}
					open={true}
					dimmer={'blurring'}
					header={translate('Lưu ý')}
					content={translate('Bạn có chắc chắn muốn xóa giấy tờ này ?')}
					size='mini'
					cancelButton={() => {
						return (
							<DefaultButton
								text={'Đóng'}
								onClick={() => {
									setGiayTopNopChiTietDeletedId(0);
								}}
							/>
						);
					}}
					confirmButton={() => {
						return <DangerButton text={'Xóa giấy tờ'} onClick={handleDeleteGiayToChiTiet} />;
					}}
				/>
			)}
			{isShowInsertConfirm && (
				<Confirm
					className={styles.modal_center}
					open={true}
					dimmer={'blurring'}
					header={translate('Xác nhận')}
					content={translate('Bạn có chắc chắn muốn cập nhật hồ sơ, giấy tờ ?')}
					size='mini'
					cancelButton={() => {
						return (
							<DefaultButton
								onClick={() => {
									setIsShowInsertConfirm(false);
								}}
								text='Đóng'
							/>
						);
					}}
					confirmButton={() => {
						return <PrimaryButton onClick={handleSaveChanges} text='Cập nhật' />;
					}}
				/>
			)}
		</div>
	);
};

export default GiayToNopForm;
